import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="stock";
export function selectAll(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}


export function listUnit(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/listUnit`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}



export function insert(parameter){
   console.log("data:",parameter)
   return axios({
     url: `/ws/${moduleName}`,
     method: 'post',
     data:parameter
   })
}

export function update(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'put',
    data:parameter
  })
}
export function selectOne(id) {
  console.log("id:", id)
  return axios({
    url: `/ws/${moduleName}/${id}`,
    method: 'get',
  })
}

export function selectedList(parameter) {
  return axios({
    url: `/ws/${moduleName}/selectedList`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function exportFile(parameter) {
  return axios({
    url: `/ws/${moduleName}/exportFile`,
    method: 'get',
    params: parameter,
    responseType: 'blob',
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function selectOperationRecord(parameter, id) {
  return axios({
    url: `/ws/${moduleName}/${id}/operationRecord`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function datadict() {

  return axios({
    url: `/ws/${moduleName}/datadict`,
    method: 'get',
  })
}

export function updateUnitStatus(parameter) {
  return axios({
    url: `/ws/${moduleName}/updateUnitStatus`,
    method: 'put',
    data:parameter
  })
}

export function deleteUnit(parameter) {
  return axios({
    url: `/ws/${moduleName}/deleteUnit`,
    method: 'put',
    data:parameter
  })
}

export default {
  insert,
  listUnit,
  datadict,
  update,
  selectAll,
  selectOne,
  selectedList,
  exportFile,
  selectOperationRecord,
  updateUnitStatus,
  deleteUnit
}
